import 'diana-v2-mobiscroll/dist/css/mobiscroll.react.min.css';
import { useEffect, useMemo } from 'react';
import { GlobalStyles } from '@mui/material';
import { createAppTheme } from '@diana/mui';
import { DianaCoreProvider, updateDocumentColorScheme, useThemeStore } from '@diana/core';
import { addSystemThemeListener, handleAnonId, handleBillingParams } from './Support';
import { Router } from './Routing/Router';

export function App() {
  const themeName = useThemeStore((store) => store.themeName);
  const primaryColor = useThemeStore((store) => store.primaryColor);
  const theme = useMemo(
    () => createAppTheme({ themeName, primaryColor }),
    [primaryColor, themeName],
  );

  handleBillingParams();

  useEffect(() => {
    handleAnonId();
    addSystemThemeListener();
  }, []);

  useEffect(() => {
    updateDocumentColorScheme(themeName);
  }, [themeName]);

  return (
    <DianaCoreProvider theme={theme}>
      <GlobalStyles styles={{ '#root': { position: 'relative' } }} />
      <Router />
    </DianaCoreProvider>
  );
}
